import React, { Component } from "react";
import BreadCrumbs from "../../Components/UI/BreadCrumbs";
import moment from "moment";
import { getDateFormat } from "../../Utils/UserFunctions";
import Wrp from "../../hoc/Wrp/Wrp";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import TableRecord from "../../Components/UI/TableRecord";
import HeaderTabs from "../../Components/UI/HeaderTabs";
import { callDELETE, callGET, callPOST } from "../../Utils/ApiUtil";
import Buttons from "../../Components/UI/TableRecord/TableData/Button";
import CreateNewDomain from "./DomainConfig/CreateNewDomain";
import DomainVerification from "./DomainConfig/DomainVerification";
import SearchCertificate from "./DomainCertificate/SearchCertificate";
import DomainToLive from "./DomainConfig/DomainToLive";
import { call } from "file-loader";

class DomainManagement extends Component {
  state = {
    DomainConfigList: [],
    isCreateNewModelOpen: false,
    pageTittle:'Add Domain',
    isCertificateSearchModel: false,
    isDomainNameValid: false,
    isDomainNameChanged: false,
    CertificateSearchId: "",
    item: [],
    domainSuggestion: [],
    domainViolation: [],
    SelectedCertificateId: "",
    isVerificationModelOpen: false,
    isDomainLiveModelOpen: false,
    liveMessage: {
      succMessage: "",
      failMessage: "",
    },
    domainMessage: {
      succMessage: "",
      failMessage: "",
    },
    verifyMessage:{
        succMessage:'',
        failMessage:''
    },
   
    CertificateSearchTableRecord: {
      tableHead: [
        {
          type: "RadioButton",
          columnId: "",
          isShow: true,
          attributes: { style: { width: "30px" } },
        },
        {
          name: "Lable Name ",
          type: "HyperLink",
          clickHandler: "",
          isShow: true,
          attributes: {},
        },
        {
          name: "Certificate Type",
          type: "Text",
          clickHandler: "",
          isShow: true,
          attributes: {},
        },
        {
          name: "Is Active ",
          type: "Status",
          clickHandler: "",
          isShow: true,
          attributes: {},
        },
        {
          name: "Created at",
          type: "Text",
          clickHandler: "",
          isShow: true,
          attributes: {},
        },
        {
          name: "Certificate Expiry Date ",
          type: "Date",
          clickHandler: "",
          isShow: true,
          attributes: {},
        },
      ],
      tableData: [],
      pagination: {
        page: 0,
        orderBy: "",
        perPage: 10,
        direction: "ASC",
        totalRecords: 0,
        search: "",
      },
      isApplyFilter: false,
    },
    tableRecords: {
      tableHead: [
        {
          name: "Action",
          type: "Actions",
          href: "",
          isShow: true,
          clickHandler: "",
          attributes: {
            style: { width: "75px" },
          },
        },
        {
          name: "Domain Name ",
          type: "Text",
          clickHandler: "",
          isShow: true,
          attributes: {},
        },
        {
          name: "Domain Status ",
          type: "Text",
          clickHandler: "",
          isShow: true,
          attributes: {},
        },
        {
          name: "HTTPS certificate",
          type: "s",
          clickHandler: "",
          isShow: true,
          attributes: {},
        },
        {
          name: "Domain To Live",
          type: "Text",
          clickHandler: "",
          isShow: true,
          attributes: {},
        },
      ],
      tableData: [],
      pagination: {
        page: 0,
        orderBy: "",
        perPage: 10,
        direction: "ASC",
        totalRecords: 0,
        search: "",
      },
      isApplyFilter: false,
    },
  };

  componentDidMount = () => {
    this.getDomainList();
  };

  defaultOnclickHandler = () => {};
  toggleModelHandler = (model) => {
    if (model !== undefined && model !== "") {
      this.setState({
        isCreateNewModelOpen:
          model === "create" ? !this.state.isCreateNewModelOpen : false,
        isVerificationModelOpen:
          model === "verify" ? !this.state.isVerificationModelOpen : false,
        isCertificateSearchModel:
          model === "search" ? !this.state.isCertificateSearchModel : false,
        isDomainLiveModelOpen:
          model === "live" ? !this.state.isDomainLiveModelOpen : false,
      });
    }
  };

  toggleCertificateSearchModel = (item) => {
    console.log("toggleCertificateSearchMdoel", item);
    this.toggleModelHandler("search");
    this.setState({
      item: item,
      SelectedCertificateId:(item.certificate_id!==undefined)?item.certificate_id:""
    });
    this.getAvailableCertificate();
  };

  //domain name change handler
  valueChangeHandler = (e) => {
    let value = e.currentTarget.value;

    console.log("valueChangeHandler", value);
    let isValid = this.validateDomainName(value);
    const { item } = this.state;
    this.setState({
      item: {
        ...item,
        domain_name: value,
      },
      isDomainNameValid: isValid,
      isDomainNameChanged: true,
    });
  };

  domainSuggestionSelect = (domainName) => {
    console.log("domainSuggestionSelect", domainName);
    if (this.state.item.domain_name !== domainName) {
      this.setState({
        item: { ...this.state.item, domain_name: domainName },
        isDomainNameValid: true,
      });
    }
  };

  validateDomainName = (name) => {
    console.log("ValidatingDomainName", name, "length", name.length);
    let nameSplit = name.split(".");
    let isValid = false;
    let suggestion = this.state.domainSuggestion;
    let violation = [];
    let domainExtention = ["com", "net", "in", "org"];
    console.log(
      "ValidatingDomainName",
      name,
      "length",
      name.length,
      "nameSplit",
      nameSplit,
      "lastChar",
      name.substr(name.length - 1)
    );
    if (nameSplit.length > 1) {
      //checking domain extension present and length 2 to 6
      if (name.substr(name.length - 1) !== ".") {
        isValid = true;
        if (nameSplit[nameSplit.length - 1].length < 2) {
          violation.push("domain extension should be atleast 2 char long");
        }
        if (nameSplit[nameSplit.length - 1].length > 6) {
          violation.push("domain extension can not be more than 6 char long");
        }
      }
    }
    if (nameSplit.length > 1 && name.substr(0, 1) === ".") {
      violation.push("domain name staring with . is not vaid");
      isValid = false;
    }

    //Adding suggestion list for domain when ends with .
    if (
      nameSplit.length > 1 &&
      name.substr(0, 1) !== "." &&
      name.substr(name.length - 1) === "."
    ) {
      console.log("inside suggestion");
      domainExtention.forEach((item) => {
        if (suggestion.includes(nameSplit.join(".") + item) === false) {
          suggestion.push(nameSplit.join(".") + item);
        }
      });
    }
    if (name.length > 1 && !name.includes(".")) {
      suggestion = [];
      // violation.push("")
    }

    if (suggestion !== this.state.domainSuggestion) {
      this.setState({
        domainSuggestion: suggestion,
      });
    }
    if (this.state.domainViolation !== violation) {
      this.setState({
        domainViolation: violation,
      });
    }
    const regexPatter =
      "(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\\.)+[a-z0-9][a-z0-9-]{0,6}[a-z0-9]";
    var matchValue = name.match(regexPatter);
    console.log("matcher", matchValue);
    if (matchValue === null) {
      isValid = false;
    } else if (matchValue[0] === name) {
      isValid = true;
    } else {
      isValid = false;
    }

    // console.log('result',result)

    console.log("isValid", isValid, "value", name);
    return isValid;
  };
  //domain Verification Screen toggle
  toggleDomainVerification = (item) => {
    console.log("toggleDomain Verificateion");
    if (item !== null && item !== undefined && item !== this.state.item) {
      this.setState({
        item: item,
        verifyMessage:{
            succMessage:'',
            failMessage:''
        }
      });
    }
    this.toggleModelHandler("verify");
  };

 
  toggleDomainToLive = (item) => {
    console.log("toggleDomainToLive");
    if (item !== null && item !== undefined && item !== this.state.item) {
      this.setState({
        item: item,
        liveMessage: {
          failMessage: "",
          succMessage: "",
        },
      });
    }
    this.toggleModelHandler("live");
  };

  //domain name saving

  saveHandler = () => {
    console.log("Saving domain name", this.state.item.domain_name);
    const header = { "Content-Type": "application/json" };
    const { item } = this.state;
    let API = "domain/save";
    let body = { ...item };
    console.log("body", body);
    this.props.Loader();
    callPOST(API, body, header).then(
      (response) => {
        const responseData = response.data;
        console.log("responseData", responseData);
        this.props.Loader();
        if (responseData.code === 200) {
          this.getDomainList();

          this.props.succMessage(responseData.message);
          console.log("responseData", responseData);
          this.setState({
            isCreateNewModelOpen: false,
          });
        } else {
          console.log("violation", responseData.violations[0]);

          if (
            responseData.violations !== undefined &&
            responseData.violations.length > 0
          ) {
            this.props.failMessage(responseData.violations[0].message);
          } else {
            this.props.failMessage(responseData.message);
          }
        }
      },
      (error) => {
        console.log("error", error);
        this.props.failMessage("Something Went Wrong");
        this.props.Loader();
      }
    );
  };

  //Checking domain live

  checkLive = (domain) => {
    console.log("checklive", domain);
    // const body={'domain':item.domain_name}
    this.props.Loader();
    callGET("domain/check-live?domain=" + domain).then(
      (response) => {
        const responseData = response.data;
        this.props.Loader();
        if (responseData.code === 200) {
          // this.toggleModelHandler("live")
          this.setState({
            liveMessage: {
              failMessage: "",
              succMessage: responseData.message,
            },
          });
        } else if (responseData.code !== 500) {
          this.setState({
            liveMessage: {
              failMessage: responseData.message,
              succMessage: "",
            },
          });
        }
      },
      (error) => {
        console.log("error", error);
      }
    );
  };
  openDomainToLive = (item) => {
    console.log("openDomainToLive", item);
    if (this.state.item !== item) {
      this.setState({
        item: item,
      });
    }
    this.toggleModelHandler("live");
  };

  //get list of availble domain based on or
  getDomainList = (paginationRequest, loader) => {
    const { Loader } = this.props;
    let pagination = this.state.tableRecords.pagination;
    if (paginationRequest !== null && paginationRequest !== undefined) {
      pagination = paginationRequest;
      this.setState({ pagination: paginationRequest });
    }
    console.log("getDomainListpagination", paginationRequest);
    const page = pagination.page;
    const orderBy = pagination.orderBy;
    const perPage = pagination.perPage;
    const direction = pagination.direction;
    const search = pagination.search;
    const queryString =
      "?query=" +
      search +
      "&page=" +
      page +
      "&orderBy=" +
      orderBy +
      "&size=" +
      perPage +
      "&direction=" +
      direction;
    let API_URL = "domain/search";
    Loader();
    callGET(API_URL + queryString).then(
      (response) => {
        Loader();
        if (response.status === 200) {
          const responseData = response.data.data;
          console.log("responseData", responseData);
          let updateTableData = responseData.content.map((item) => {
            console.log("item", item);
            let DomainVerified = (
              <>
                <i className="fas fa-check text-success" />
                <span className="text-success"> Verified </span>
              </>
            );

            // let HttpsCertificationNotConfigured = (
            //   <>
            //     <span className="text-danger"> Not Configured </span>
            //     <a
            //       onClick={(e) => {
            //         this.toggleCertificateSearchModel(item);
            //       }}
            //       className="text-info textUnderline cursor-pointer"
            //       data-toggle="modal"
            //       data-target="#c_Search"
            //     >
            //       {" "}
            //       <i className="fas fa-search"></i> Search{" "}
            //     </a>
            //   </>
            // );
            // let HttpsCertificationConfigured = (
            //   <>
            //     <span className="text-success"> Configured </span>
            //     <a
            //       onClick={(e) => {
            //         this.toggleCertificateSearchModel(item);
            //       }}
            //       className="text-info textUnderline cursor-pointer"
            //       data-toggle="modal"
            //       data-target="#c_Search"
            //     >
            //       {" "}
            //       <i className="fas fa-search"></i> Search{" "}
            //     </a>
            //   </>
            // );

            let DomainNotVerified = (
              <>
                <i className="fas fa-times text-danger" />
                <span className="text-danger"> Not Verified </span>{" "}
                <span className="text-small">
                  <a
                    onClick={(e) => {
                      this.toggleDomainVerification(item);
                    }}
                    className={(this.state.isVerificationModelOpen===true)?"text-info textUnderline cursor-pointer quick-sidebar-toggler toggled":"text-info textUnderline cursor-pointer  quick-sidebar-toggler"}
                  >
                    {" "}
                    Verify Now{" "}
                  </a>
                </span>
              </>
            );

            return {
              actions: [
                {
                  type: "edit",
                  attributes: {
                    className: "p-1",
                  },
                  name: "",
                  clickHandler: this.editHandler.bind(this, item),
                },
                {
                  type: "delete",
                  attributes: {
                    className: "p-1",
                  },
                  clickHandler: this.deleteDomainHandler.bind(this, item.id),
                  name: "",
                },
              ],
              domain_name:
                item.domain_name !== undefined ? (
                  <>
                    <span>
                      {" "}
                      <a
                        className="text-info textUnderline cursor-pointer"
                        href={"https://" + item.domain_name + "/"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.domain_name}
                      </a>
                    </span>
                  </>
                ) : (
                  ""
                ),
              domainStatus: item.is_active ? DomainVerified : DomainNotVerified,
              HttpsCertification: item.is_active ? (
                <>
                  <a
                    onClick={(e) => {
                      this.toggleCertificateSearchModel(item);
                    }}
                    className="text-info textUnderline cursor-pointer"
                    data-toggle="modal"
                    data-target="#c_Search"
                  >
                    {" "}
                    <i className="fas fa-search"></i> Search{" "}
                  </a>
                </>
              ) : (
                "-"
              ),
              sslExpiry: item.is_certificate_added ? (
                <>
                  <a
                    onClick={(e) => {
                      this.openDomainToLive(item);
                    }}
                    className="text-info textUnderline cursor-pointer"
                  >
                    {" "}
                    <i className="fas fa-search"></i> check Live{" "}
                  </a>
                </>
              ) : (
                "-"
              ),
            };
          });

          console.log("domainList Data", updateTableData);
          const totalRecords = responseData.total_elements;
          this.setState({
            DomainConfigList: responseData.content,
            tableRecords: {
              tableData: { data: updateTableData, status: 200 },
              tableHead: this.state.tableRecords.tableHead,
              pagination: {
                ...this.state.tableRecords.pagination,
                totalRecords: totalRecords,
              },
            },
          });
        }
      },
      (error) => {
        console.log("error", error);
        Loader();
      }
    );

    console.log("getDomainList END", this.state);
  };

  mapCertificate=()=>{
    console.log('mapCertificate');
    let domainId = this.state.item.id;
    let certificateId = this.state.SelectedCertificateId;
    if(domainId!==""){
      this.props.Loader();
      console.log('domainId',domainId,"certificateId",certificateId);
      const URL = "domain/map?domainId="+domainId+"&certificateId="+certificateId;
      callGET(URL).then(
        (response) => {
          const responseData = response.data;
          console.log('response',response);
          this.props.Loader();
          if (responseData.code === 200) {
            this.getDomainList();
            this.props.succMessage(responseData.message);
            this.setState({
              SelectedCertificateId:"",
              isCertificateSearchModel:false
            })
          } else {
            this.props.failMessage(responseData.message);
          }
        },
        (error) => {
          this.props.Loader();
          console.log("error", error);
        }
      );
    }
    
  }




  editHandler = (item) => {
    this.props.history.push("/domain-management/domain-config/edit/"+item.id)
  };

  DomainVerification = (id) => {
    console.log("DoaminVerification", id);
    if (this.state.item !== undefined) {
      const { item } = this.state;
      let API = "domain/verify/" + item.id;
      this.props.Loader();
      callPOST(API).then(
        (response) => {
          const responseData = response.data;
          this.props.Loader();
          if (responseData.code === 200) {
            this.props.succMessage(responseData.message);
            this.setState({
                isVerificationModelOpen:false 
            });
            this.getDomainList();
          } else {
            this.setState({
                verifyMessage:{
                  succMessage:"",
                  failMessage:responseData.message
                } 
              });
          }
        },
        (error) => {
          this.props.Loader();
          console.log("error", error);
        }
      );
    }
  };

  // CheckBoxClickHandler = (item) => {
  //   console.log("Checkbox cliked", item);
    //NEw  Logic to update SelectedCertificateId


  // Old Logic to update current domain state and save
    
    // let UpdatedDomain = this.state.item;
    // if (item.id !== UpdatedDomain.certificate_id) {
    //   UpdatedDomain = {
    //     ...UpdatedDomain,
    //     certificate_id: item.id,
    //     certificate_added: true,
    //   };
    //   this.updateTableRecords(item.id);
    // } else {
    //   UpdatedDomain = {
    //     ...UpdatedDomain,
    //     certificate_id: "",
    //     is_certificate_added: false,
    //   };
    //   this.updateTableRecords(UpdatedDomain.id);
    // }
    // console.log("UpdateDomain", UpdatedDomain);
    // this.setState({
    //   item: UpdatedDomain,
    // });
  // };


  //Search Certificate click Handler
  CheckBoxClickHandler = (rowId) => {
    console.log("updateTableRecords", rowId);
    const tableDataSel = this.state.CertificateSearchTableRecord;
    tableDataSel.tableData.data.map((item, index) => {
      if (item.rowId === rowId) {
        let CurrentState =
          tableDataSel.tableData.data[index].data.RadioButton.checked;
        if (CurrentState === false) {
          tableDataSel.tableData.data[index].className = "selected";
          tableDataSel.tableData.data[index].data.RadioButton.checked = true;
        } else {
          tableDataSel.tableData.data[index].className = "";
          tableDataSel.tableData.data[index].data.RadioButton.checked = false;
        }
      } else {
        tableDataSel.tableData.data[index].className = "";
        tableDataSel.tableData.data[index].data.RadioButton.checked = false;
      }
    });
    this.setState({
      CertificateSearchTableRecord: {
        ...tableDataSel,
      },
      SelectedCertificateId:(this.state.SelectedCertificateId!==rowId)?rowId:""
    });
  };

  clearMessage = (model) => {
    console.log9("model", model);
    if (model === "domain") {
      this.setState({
        domainMessage: {
          succMessage: "",
          failMessage: "",
        },
      });
    } else if (model === "live") {
      this.setState({
        liveMessage: {
          succMessage: "",
          failMessage: "",
        },
      });
    }
  };

  //Get available Certificate for domain certificate configuration
  getAvailableCertificate = (paginationRequest) => {
    console.log("getAvailableCertificate START");
    const { Loader } = this.props;
    let pagination = this.state.CertificateSearchTableRecord.pagination;
    if (paginationRequest !== null && paginationRequest !== undefined) {
      pagination = paginationRequest;
    }
    const page = pagination.page;
    const orderBy = pagination.orderBy;
    const perPage = pagination.perPage;
    const direction = pagination.direction;
    const search = pagination.search;
    Loader();
    const queryString =
      "?query=" +
      search +
      "&page=" +
      page +
      "&orderBy=" +
      orderBy +
      "&size=" +
      perPage +
      "&direction=" +
      direction;
    let API_URL = "domain/certificate/search/active";

    callGET(API_URL + queryString).then(
      (response) => {
        Loader();
        if (response.status === 200) {
          const responseData = response.data.data;
          console.log("responseData", responseData);

          let updateTableData = [];
          if(responseData!==undefined && responseData!=null){
            responseData.content.map((item) => {
              console.log("i", item);
              const domain = this.state.item;
              if (domain.domain_name=== item.common_name) {
                let fieldRow = {
                  RadioButton: {
                    checked:
                      domain.certificate_id !== undefined &&
                      domain.certificate_id === item.id
                        ? true
                        : false,
                    name: "CertificateCheckbox",
                  },
                  lable_name: {
                    value: item.common_name !== undefined ? item.common_name : "",
                    className: "text-info textUnderline cursor-pointer",
                  },
                  type: item.type !== undefined ? item.type : "-",
                  is_active: {
                    checked: item.is_active,
                  },
                  created_at: item.created_at,
                  certificate_expiry:
                    item.expiry_date !== undefined
                      ? moment(item.expiry_date).format(getDateFormat())
                      : "-",
                };
  
                updateTableData.push({
                  clickHandler: this.CheckBoxClickHandler.bind(this, item.id),
                  className:
                    domain.certificate_id !== undefined &&
                    domain.certificate_id === item.id
                      ? "selected"
                      : "",
                  rowId: item.id,
                  data: fieldRow,
                });
              }
            });
  
            console.log("getAvailableCertificate Data", updateTableData);
           const totalRecords = responseData.total_elements;
            this.setState({
              CertificateSearchTableRecord: {
                tableData: { data: updateTableData, status: 200 },
                tableHead: this.state.CertificateSearchTableRecord.tableHead,
                pagination: {
                  ...this.state.CertificateSearchTableRecord.pagination,
                  totalRecords: totalRecords,
                },
              },
            });
          }
          
        }
     
      },
      (error) => {
        console.log("error", error);
        Loader();
      }
    );
    console.log("getAvailableCertificate END", this.state);
  };
  checkDomainAvailability = (domainName) => {
    console.log("checking domain availability", domainName);
    const { isDomainNameValid } = this.state;

    if (domainName === "") {
      this.props.failMessage("please enter domain name");
    } else if (!isDomainNameValid) {
      this.props.failMessage("please enter valid domain name");
    } else {
      callGET("domain/check-available?name=" + domainName).then(
        (response) => {
          const responseData = response.data;
          console.log("response", responseData);
          if (responseData.code === 200) {
            this.props.succMessage(responseData.message);
            this.setState({
                domainSuggestion:[]
            })
          } else {
            this.props.failMessage(responseData.message);
          }
        },
        (error) => {
          console.log("error", error);
        }
      );
    }
  };

  recordChangeHandler = async (paginationRequest, loader) => {
    const tableRecords =this.state.tableRecords;
    let pagination = this.state.tableRecords.pagination;
    if (paginationRequest !== undefined && paginationRequest !== null) {
      pagination = { pagination, ...paginationRequest };
      
      this.setState({ tableRecords: {...tableRecords,pagination:pagination} });
      this.getDomainList(pagination);
    }
  };


  searchCertificateChangeHandler=async (paginationRequest, loader) =>{
    console.log('searchCertificateHandler',paginationRequest,"loader",loader);
    
    const tableRecords =this.state.CertificateSearchTableRecord;
    let pagination = tableRecords.pagination;
    if (paginationRequest !== undefined && paginationRequest !== null) {
      pagination = { pagination, ...paginationRequest };

      this.setState({ CertificateSearchTableRecord: {...tableRecords,pagination:pagination} });
      this.getAvailableCertificate(pagination);
    }
  }
  
  deleteDomainHandler = (id) => {
    // console.log('deleteDomainHandler',id)
    const { Loader, succMessage, failMessage } = this.props;
    Loader();
    callDELETE("domain/" + id + "/delete").then(
      (response) => {
        const responseData = response.data;
        Loader();
        console.log("response", response);
        if (response.status === 200) {
          this.getDomainList();
          succMessage(responseData.message);
        } else {
          failMessage(responseData.message);
        }
      },
      (error) => {
        Loader();
        console.log("error", error);
      }
    );
  };
  toogleCreateNewHandler = () => {
    // console.log("toogleCreateNewHandler");
    // this.setState({
    //   item: {domain_name:""},
    //   pageTitle:"Add Domain",
    //   domainViolation: [],
    //   domainSuggestion: [],
    //   isDomainNameChanged: false,
    //   domainMessage: {
    //     succMessage: "",
    //     failMessage: "",
    //   },
    // });
    // this.toggleModelHandler("create");
    this.props.history.push("/domain-management/domain-config/create")
  };


  getAndSetBreadCrumbs = () => {
    return {
      backHistory: [
        {
          href: "/settings",
          name: "Settings",
        },
      ],
      pageTitle: "Domain Management",
      buttonList: [
        {
          name: "Add New",
          type: "addNew",
          clickHandler: this.toogleCreateNewHandler,
          attributes: {
            className: "btn primary_bg",
          },
        },
      ],
    };
  };

  render() {
    const breadCrumbs = this.getAndSetBreadCrumbs();
    // const hideClass = " d-sm-none d-md-none d-lg-block d-none";
    const headerTabs = [
      {
        name: "Domain Config",
        attributes: {
          "aria-selected": true,
          className: "nav-link active show",
        },
        href: "/domain-management/domain-config",
      },
      {
        name: "Certificate Config",
        attributes: {
          "aria-selected": false,
          className: "nav-link",
        },
        href: "/domain-management/certificate-config",
      },
    ];

    return (
      <Wrp>
        <BreadCrumbs breadCrumbsList={breadCrumbs} />
        <HeaderTabs
          attributes={{
            className:
              "nav nav-pills navcrm-primary nav-pills-no-bd fixed-2",
          }}
          headerTabsList={headerTabs}
        />
        <div className="viewport" style={{ background: "transparent" }}>
          <div className="view view-xl">
            
            {this.state.tableRecords.pagination.totalRecords === 0 ? (
              <div className="outerPort" >
                <div className="table_Box dataTables_wrapper">
                  <div className="table_Body d-flex align-items-center justify-content-center">
                    <div className="text-center" style={{ zIndex: "1" }}>
                      <h4 className="mb-3" style={{ color: "#1d7af3" }}>
                        {" "}
                        Add Domain and Check the Availability
                      </h4>
                      <div className="btn-group">
                          <a href="#" onClick={this.toogleCreateNewHandler} className="btn primary_bg" > 
                            <i className="fas fa-plus smoky_light_color"></i>+Add New Domain
                          </a>
                        </div>
                      
                    </div>
                  </div>
                </div>
                <div className="kanbanSkelton">
                  <img src="/assets/img/Skeleton_View.jpg" />
                </div>
              </div>
            ) : (
              <div className="outerPort" >
                <TableRecord
                  tableRecords={this.state.tableRecords}
                  recordsChangeHandler={this.recordChangeHandler}
                />
              </div>
            )}

            {/* } */}
            <CreateNewDomain
              {...this.props}
              {...this.state}
              valueChangeHandler={this.valueChangeHandler}
              toggleModel={this.toogleCreateNewHandler}
              saveHandler={this.saveHandler}
              checkAvailable={this.checkDomainAvailability}
              domainSuggestion={this.state.domainSuggestion}
              domainSuggestionSelect={this.domainSuggestionSelect}
            />
            <SearchCertificate
              {...this.props}
              isModelOpen={this.state.isCertificateSearchModel}
              SelectedCertificateId={this.state.SelectedCertificateId}
              tableRecords={this.state.CertificateSearchTableRecord}
              searchCertificateChangeHandler={this.searchCertificateChangeHandler}
              saveHandler={this.mapCertificate}
              toggleModel={this.toggleCertificateSearchModel}
              certificateReload={this.getAvailableCertificate}
            />
            <DomainVerification
              
              isModalOpen={this.state.isVerificationModelOpen}
              message={this.state.verifyMessage}
              toggleModel={this.toggleDomainVerification}
              VerifyHandler={this.DomainVerification.bind()}
              item={this.state.item}
            />
            <DomainToLive
              checkLive={this.checkLive}
              isModalOpen={this.state.isDomainLiveModelOpen}
              message={this.state.liveMessage}
              toggleModel={this.toggleDomainToLive}
              item={this.state.item}
            />
          </div>
        </div>
      </Wrp>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    Loader: (msg) => dispatch(actions.loader(msg)),
    succMessage: (msg) => dispatch(actions.succMessage(msg)),
    failMessage: (msg) => dispatch(actions.failMessage(msg)),
  };
};
export default connect(
  null,
  mapDispatchToProps
)(withRouter(withTranslation()(DomainManagement)));
